module.exports = __webpack_public_path__ + "img/certification.d99d3d33.png";